exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._5NYqo{cursor:pointer}span._3aS-z,span._5NYqo{font-size:16px;margin:0 8px}.-s5vh{background:#f9fad2}._3HLmD{color:#700;font-weight:700;background:#f3d8d8}._2mid7:not(._28G2f):not(._1prry){background:#d8f3d8}._28G2f,.YBM0g{background:#f3d8d8}._28G2f{color:#8b0000}._3NOct{background:#fff3cd;color:#856404}._1prry{background:#f3d8d8;color:#8b0000}._31ZzA{padding:0!important}._1vwC1,._30Nhu{padding:7px 3px}._1vwC1{line-height:30px}.xBZfz div{overflow-x:hidden!important}.xBZfz div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "_5NYqo",
	"info": "_3aS-z",
	"noComisionable": "-s5vh",
	"errorComision": "_3HLmD",
	"documentoFirmado": "_2mid7",
	"facturaCancelada": "_28G2f",
	"instanciaCaducada": "_1prry",
	"documentoNoFirmado": "YBM0g",
	"docIncompleta": "_3NOct",
	"tdClear": "_31ZzA",
	"field": "_30Nhu",
	"fieldAsignacion": "_1vwC1",
	"hidden": "xBZfz"
};